import React from 'react';

export default {
  outline: (
    <>
      <g id="bg-lines" strokeWidth="0.5">
        <polyline
          id="Path"
          stroke="#262626"
          points="481 134 524 134 524 160 481 160 481 134"
        />
        <path d="M486.5,134 L486.5,160" id="Path" stroke="#262626" />
        <path d="M493.5,134 L493.5,160" id="Path" stroke="#262626" />
        <polyline
          id="Path"
          stroke="#262626"
          points="481 105 524 105 524 131 481 131 481 105"
        />
        <path d="M499.5,134 L499.5,160" id="Path" stroke="#262626" />
        <path d="M505.5,134 L505.5,160" id="Path" stroke="#262626" />
        <path d="M511.5,134 L511.5,160" id="Path" stroke="#262626" />
        <path d="M517.5,134 L517.5,160" id="Path" stroke="#262626" />
        <path d="M486.5,105 L486.5,131" id="Path" stroke="#262626" />
        <path d="M493.5,105 L493.5,131" id="Path" stroke="#262626" />
        <path d="M499.5,105 L499.5,131" id="Path" stroke="#262626" />
        <path d="M505.5,105 L505.5,131" id="Path" stroke="#262626" />
        <path d="M511.5,105 L511.5,131" id="Path" stroke="#262626" />
        <path d="M517.5,105 L517.5,131" id="Path" stroke="#262626" />
        <polygon
          id="Path"
          stroke="#979797"
          fillRule="nonzero"
          points="451 105 549 105 549 160 451 160"
        />
        <polyline
          id="Path"
          stroke="#262626"
          points="250 134 293 134 293 160 250 160 250 134"
        />
        <path d="M255.5,134 L255.5,160" id="Path" stroke="#262626" />
        <path d="M262.5,134 L262.5,160" id="Path" stroke="#262626" />
        <polyline
          id="Path"
          stroke="#262626"
          points="250 105 293 105 293 131 250 131 250 105"
        />
        <path d="M268.5,134 L268.5,160" id="Path" stroke="#262626" />
        <path d="M274.5,134 L274.5,160" id="Path" stroke="#262626" />
        <path d="M280.5,134 L280.5,160" id="Path" stroke="#262626" />
        <path d="M286.5,134 L286.5,160" id="Path" stroke="#262626" />
        <path d="M255.5,105 L255.5,131" id="Path" stroke="#262626" />
        <path d="M262.5,105 L262.5,131" id="Path" stroke="#262626" />
        <path d="M268.5,105 L268.5,131" id="Path" stroke="#262626" />
        <path d="M274.5,105 L274.5,131" id="Path" stroke="#262626" />
        <path d="M280.5,105 L280.5,131" id="Path" stroke="#262626" />
        <path d="M286.5,105 L286.5,131" id="Path" stroke="#262626" />
        <polygon
          id="Path"
          stroke="#979797"
          fillRule="nonzero"
          points="220 105 318 105 318 160 220 160"
        />
        <polyline
          id="Path"
          stroke="#262626"
          points="43.4400987 0.679983806 0.440098718 0.679983806 0.440098718 151.394999 43.4400987 151.394999 43.4400987 0.679983806"
        />
        <polyline
          id="Path"
          stroke="#262626"
          points="43.4400987 151.394999 0.440098718 151.394999 0.440098718 337.589387 43.4400987 337.589387 43.4400987 151.394999"
        />
        <polyline
          id="Path"
          stroke="#262626"
          points="645.634249 11.2901053 721.283933 11.2901053 721.283933 35.6376953"
        />
        <polyline
          id="Path"
          stroke="#262626"
          points="661 338.203017 661 342.123023 721.19513 342.123023 721.19513 311"
        />
        <polyline
          id="Path"
          stroke="#262626"
          points="491.16774 337.581796 491.16774 340.057491 417 340.057491 417 337.015923"
        />
        <polyline
          id="Path"
          stroke="#262626"
          points="354.814896 337.015923 354.814896 340.057491 281 340.057491 281 337.157391"
        />
        <polyline
          id="Path"
          stroke="#262626"
          points="272.022609 202.818721 226.505776 202.818721 226.505776 236.27597 272.022609 236.27597 272.022609 202.818721"
        />
        <path
          d="M331.863239,1.63841565 L418.397461,1.63841565"
          id="Path"
          stroke="#262626"
        />
        <polygon
          id="Path"
          stroke="#262626"
          fillRule="nonzero"
          points="222.271652 240.661487 222.271652 198.221001 276.256733 198.221001 276.256733 240.661487"
        />
        <path
          d="M450.879883,160 L403.323242,160"
          id="Path-2"
          stroke="#262626"
        />
      </g>
      <path
        d="M679.28,163.06 L678.8,164.5 L676,173.1 L675,173.1 L670.36,159.3 L669.2,159.2 L669.2,159 L674.2,159 L674.2,159.2 L672.26,159.3 L676.14,171.3 L676.34,171.3 L679.12,162.5 L678.16,159.3 L676.6,159.2 L676.6,159 L681.8,159 L681.8,159.2 L680.06,159.3 L683.44,171.3 L683.64,171.3 L686.66,159.9 L684.6,159.2 L684.6,159 L689,159 L689,159.2 L686.98,159.9 L683.4,173.1 L682.3,173.1 L679.28,163.06 Z M696.665,167.2 L689.825,167.2 C689.765,169.8 691.125,172.1 693.465,172.1 C694.765,172.1 696.165,171.2 696.665,170.2 L696.865,170.2 C696.465,171.8 694.965,173.2 693.065,173.2 C689.965,173.2 688.265,170.7 688.265,168 C688.265,164.7 690.665,162.8 693.165,162.8 C695.065,162.8 697.265,163.9 696.665,167.2 Z M693.065,163 C691.345,163 690.065,164.4 689.865,167 L694.865,166.9 C695.365,164.2 694.365,163 693.065,163 Z M702.43,173.2 C701.17,173.2 700.09,172.62 699.43,172 L699.33,173.2 L699.13,173.2 L699.13,170.2 L699.33,170.2 C699.57,170.88 699.93,171.56 700.39,172.1 C700.85,172.64 701.45,173 702.23,173 C703.63,173 704.53,172.12 704.53,170.9 C704.53,169.4 703.07,168.96 701.93,168.5 C700.39,167.88 699.23,167.2 699.23,165.5 C699.23,163.9 700.57,162.8 702.63,162.8 C703.45,162.8 704.53,163.1 705.43,163.9 L705.53,162.8 L705.73,162.8 L705.73,165.8 L705.53,165.8 C705.23,164.8 704.77,164.12 704.25,163.66 C703.73,163.22 703.13,163 702.53,163 C701.33,163 700.63,163.82 700.63,164.8 C700.63,166.1 701.93,166.7 703.03,167.1 C704.51,167.64 706.13,168.4 706.13,170.2 C706.13,172.1 704.53,173.2 702.43,173.2 Z M711.395,163.3 L711.395,170.8 C711.395,172.3 711.895,172.7 712.795,172.7 C713.195,172.7 713.695,172.6 714.395,172.3 L714.395,172.5 C713.395,173 712.795,173.2 711.795,173.2 C710.395,173.2 709.795,172.5 709.795,170.8 L709.795,163.3 L708.195,163.3 L708.195,163.1 L709.795,163 L711.195,160.6 L711.395,160.6 L711.395,163 L714.395,163 L714.395,163.3 L711.395,163.3 Z M721.725,172.8 L724.325,172.7 L724.325,159.5 L721.725,159.9 L721.725,159.7 L725.725,158.8 L725.925,158.8 L725.925,172.7 L728.525,172.8 L728.525,173 L721.725,173 L721.725,172.8 Z M734.790001,173 C736.710001,173 737.750001,171.36 737.750001,169.24 C737.750001,167.42 736.870001,165.64 734.730001,165.64 L734.010001,165.64 L734.010001,165.4 L734.530001,165.4 C736.350001,165.4 737.230001,163.66 737.230001,162.28 C737.230001,160.92 736.390001,159.6 734.790001,159.6 C732.790001,159.6 731.990001,160.9 731.590001,161.98 L731.390001,161.98 C731.790001,160.3 733.390001,158.8 735.290001,158.8 C737.430001,158.8 738.970001,160.06 738.970001,161.96 C738.970001,163.64 737.710001,164.84 735.430001,165.42 L735.430001,165.52 C737.810001,165.74 739.490001,166.92 739.490001,169.16 C739.490001,171.88 737.190001,173.2 734.690001,173.2 C732.510001,173.2 730.790001,171.9 730.790001,170.6 C730.790001,170.04 731.230001,169.6 731.790001,169.6 C733.250001,169.6 733.270001,171.88 731.490001,171.5 L731.490001,171.7 C731.990001,172.1 732.790001,173 734.790001,173 Z M745.155001,163.3 L745.155001,170.8 C745.155001,172.3 745.655001,172.7 746.555001,172.7 C746.955001,172.7 747.455001,172.6 748.155001,172.3 L748.155001,172.5 C747.155001,173 746.555001,173.2 745.555001,173.2 C744.155001,173.2 743.555001,172.5 743.555001,170.8 L743.555001,163.3 L741.955001,163.3 L741.955001,163.1 L743.555001,163 L744.955001,160.6 L745.155001,160.6 L745.155001,163 L748.155001,163 L748.155001,163.3 L745.155001,163.3 Z M759.820001,172.7 L761.620001,172.8 L761.620001,173 L756.820001,173 L756.820001,172.8 L758.220001,172.7 L758.220001,165.8 C758.220001,164.5 757.820001,163.4 756.320001,163.4 C755.420001,163.4 754.820001,163.7 753.420001,165.1 L753.420001,172.7 L755.220001,172.8 L755.220001,173 L750.020001,173 L750.020001,172.8 L751.820001,172.7 L751.820001,158.8 L750.220001,158.8 L750.220001,158.6 L753.220001,158.4 L753.420001,158.4 L753.420001,164.6 L753.620001,164.6 C754.780001,163.44 755.860001,162.8 757.320001,162.8 C758.660001,162.8 759.820001,163.6 759.820001,165.8 L759.820001,172.7 Z M770.250001,172.1 L772.350001,172.8 L772.350001,173 L767.950001,173 L767.950001,172.8 L769.930001,172.1 L773.790001,160.1 L775.250001,158.8 L780.390001,172.7 L781.550001,172.8 L781.550001,173 L776.550001,173 L776.550001,172.8 L778.490001,172.7 L776.830001,168 L771.530001,168 L770.250001,172.1 Z M774.150001,160.4 L773.950001,160.4 L771.590001,167.76 L776.750001,167.76 L774.150001,160.4 Z M787.075001,171.64 L787.275001,171.64 L789.755001,163.7 L788.215001,163.2 L788.215001,163 L791.815001,163 L791.815001,163.2 L790.055001,163.7 L787.015001,173.1 L785.915001,173.1 L781.955001,163.3 L780.615001,163.2 L780.615001,163 L785.815001,163 L785.815001,163.2 L783.855001,163.3 L787.075001,171.64 Z M801.080001,167.2 L794.240001,167.2 C794.180001,169.8 795.540001,172.1 797.880001,172.1 C799.180001,172.1 800.580001,171.2 801.080001,170.2 L801.280001,170.2 C800.880001,171.8 799.380001,173.2 797.480001,173.2 C794.380001,173.2 792.680001,170.7 792.680001,168 C792.680001,164.7 795.080001,162.8 797.580001,162.8 C799.480001,162.8 801.680001,163.9 801.080001,167.2 Z M797.480001,163 C795.760001,163 794.480001,164.4 794.280001,167 L799.280001,166.9 C799.780001,164.2 798.780001,163 797.480001,163 Z M812.945001,172.7 L814.745001,172.8 L814.745001,173 L809.945001,173 L809.945001,172.8 L811.345001,172.7 L811.345001,165.8 C811.345001,164.5 810.945001,163.4 809.445001,163.4 C808.545001,163.4 807.945001,163.7 806.545001,165.1 L806.545001,172.7 L808.345001,172.8 L808.345001,173 L803.145001,173 L803.145001,172.8 L804.945001,172.7 L804.945001,163.2 L803.345001,163.2 L803.345001,163 L806.345001,162.8 L806.545001,162.8 L806.545001,164.6 L806.745001,164.6 C807.905001,163.44 808.985001,162.8 810.445001,162.8 C811.785001,162.8 812.945001,163.6 812.945001,165.8 L812.945001,172.7 Z M817.410001,163.2 L815.610001,163.2 L815.610001,163 L818.610001,162.8 L819.010001,162.8 L819.010001,170.2 C819.010001,171.5 819.410001,172.6 820.910001,172.6 C821.810001,172.6 822.410001,172.3 823.610001,170.9 L823.610001,163.2 L821.810001,163.2 L821.810001,163 L824.810001,162.8 L825.210001,162.8 L825.210001,172.8 L827.010001,172.8 L827.010001,173 L823.810001,173.2 L823.610001,173.2 L823.610001,171.4 L823.410001,171.4 C822.410001,172.5 821.370001,173.2 819.910001,173.2 C818.570001,173.2 817.410001,172.4 817.410001,170.2 L817.410001,163.2 Z M836.875001,167.2 L830.035001,167.2 C829.975001,169.8 831.335001,172.1 833.675001,172.1 C834.975001,172.1 836.375001,171.2 836.875001,170.2 L837.075001,170.2 C836.675001,171.8 835.175001,173.2 833.275001,173.2 C830.175001,173.2 828.475001,170.7 828.475001,168 C828.475001,164.7 830.875001,162.8 833.375001,162.8 C835.275001,162.8 837.475001,163.9 836.875001,167.2 Z M833.275001,163 C831.555001,163 830.275001,164.4 830.075001,167 L835.075001,166.9 C835.575001,164.2 834.575001,163 833.275001,163 Z"
        id="West-13th-Avenue"
        fill="#1A373C"
        transform="translate(753.137501, 165.800000) rotate(-90.000000) translate(-753.137501, -165.800000) "
      />
      <path
        d="M296.3,372.7 L298.4,373.4 L298.4,373.6 L294,373.6 L294,373.4 L295.98,372.7 L299.84,360.7 L301.3,359.4 L306.44,373.3 L307.6,373.4 L307.6,373.6 L302.6,373.6 L302.6,373.4 L304.54,373.3 L302.88,368.6 L297.58,368.6 L296.3,372.7 Z M300.2,361 L300,361 L297.64,368.36 L302.8,368.36 L300.2,361 Z M312.465,366 L312.665,366 C313.565,364.4 314.365,363.4 315.365,363.4 C316.005,363.4 316.465,363.84 316.465,364.4 C316.465,365.8 314.465,365.9 314.365,364.3 L314.165,364.3 C313.645,364.8 313.165,365.5 312.465,366.9 L312.465,373.3 L314.265,373.4 L314.265,373.6 L309.065,373.6 L309.065,373.4 L310.865,373.3 L310.865,363.8 L309.265,363.8 L309.265,363.6 L312.265,363.4 L312.465,363.4 L312.465,366 Z M320.53,365.04 L320.53,372.56 C321.33,373.1 322.01,373.5 323.03,373.5 C324.71,373.5 326.13,372.2 326.13,368.6 C326.13,365 324.71,363.8 323.03,363.8 C322.01,363.8 321.13,364.52 320.53,365.04 Z M318.93,373.8 L318.93,359.4 L317.33,359.4 L317.33,359.2 C318.07,359.16 318.81,359.1 320.33,359 L320.53,359 L320.53,364.6 L320.73,364.6 C321.53,363.9 322.53,363.4 323.73,363.4 C326.33,363.4 327.93,365.6 327.93,368.6 C327.93,371.6 325.93,373.8 323.33,373.8 C322.53,373.8 321.73,373.7 320.73,373 L320.53,373 L319.13,373.8 L318.93,373.8 Z M331.195,363.8 L329.395,363.8 L329.395,363.6 L332.395,363.4 L332.795,363.4 L332.795,370.8 C332.795,372.1 333.195,373.2 334.695,373.2 C335.595,373.2 336.195,372.9 337.395,371.5 L337.395,363.8 L335.595,363.8 L335.595,363.6 L338.595,363.4 L338.995,363.4 L338.995,373.4 L340.795,373.4 L340.795,373.6 L337.595,373.8 L337.395,373.8 L337.395,372 L337.195,372 C336.195,373.1 335.155,373.8 333.695,373.8 C332.355,373.8 331.195,373 331.195,370.8 L331.195,363.8 Z M345.26,363.9 L345.26,371.4 C345.26,372.9 345.76,373.3 346.66,373.3 C347.06,373.3 347.56,373.2 348.26,372.9 L348.26,373.1 C347.26,373.6 346.66,373.8 345.66,373.8 C344.26,373.8 343.66,373.1 343.66,371.4 L343.66,363.9 L342.06,363.9 L342.06,363.7 L343.66,363.6 L345.06,361.2 L345.26,361.2 L345.26,363.6 L348.26,363.6 L348.26,363.9 L345.26,363.9 Z M351.525,363.8 L349.725,363.8 L349.725,363.6 L352.725,363.4 L353.125,363.4 L353.125,370.8 C353.125,372.1 353.525,373.2 355.025,373.2 C355.925,373.2 356.525,372.9 357.725,371.5 L357.725,363.8 L355.925,363.8 L355.925,363.6 L358.925,363.4 L359.325,363.4 L359.325,373.4 L361.125,373.4 L361.125,373.6 L357.925,373.8 L357.725,373.8 L357.725,372 L357.525,372 C356.525,373.1 355.485,373.8 354.025,373.8 C352.685001,373.8 351.525,373 351.525,370.8 L351.525,363.8 Z M366.090001,373.8 C364.830001,373.8 363.750001,373.22 363.090001,372.6 L362.990001,373.8 L362.790001,373.8 L362.790001,370.8 L362.990001,370.8 C363.230001,371.48 363.590001,372.16 364.050001,372.7 C364.510001,373.24 365.110001,373.6 365.890001,373.6 C367.290001,373.6 368.190001,372.72 368.190001,371.5 C368.190001,370 366.730001,369.56 365.590001,369.1 C364.050001,368.48 362.890001,367.8 362.890001,366.1 C362.890001,364.5 364.230001,363.4 366.290001,363.4 C367.110001,363.4 368.190001,363.7 369.090001,364.5 L369.190001,363.4 L369.390001,363.4 L369.390001,366.4 L369.190001,366.4 C368.890001,365.4 368.430001,364.72 367.910001,364.26 C367.390001,363.82 366.790001,363.6 366.190001,363.6 C364.990001,363.6 364.290001,364.42 364.290001,365.4 C364.290001,366.7 365.590001,367.3 366.690001,367.7 C368.170001,368.24 369.790001,369 369.790001,370.8 C369.790001,372.7 368.190001,373.8 366.090001,373.8 Z M378.020001,372.2 L377.820001,373.7 L377.620001,373.7 L377.520001,369.4 L377.720001,369.4 C377.880001,369.86 378.060001,370.34 378.220001,370.8 C379.000001,373 380.560001,373.6 381.880001,373.6 C383.700001,373.6 384.820001,372.6 384.820001,370.68 C384.820001,368.4 382.880001,367.64 381.380001,367 C379.360001,366.14 377.820001,365 377.820001,362.96 C377.820001,361 379.320001,359.4 382.060001,359.4 C383.280001,359.4 384.420001,359.8 385.320001,360.74 L385.520001,359.5 L385.720001,359.5 L385.820001,363.5 L385.620001,363.5 C385.420001,362.94 385.220001,362.36 385.020001,361.8 C384.460001,360.2 383.400001,359.6 382.080001,359.6 C380.400001,359.6 379.120001,360.7 379.120001,362.2 C379.120001,364.1 380.940001,364.92 382.380001,365.5 C384.380001,366.3 386.320001,367.6 386.320001,369.8 C386.320001,372.2 384.560001,373.8 381.880001,373.8 C380.440001,373.8 379.020001,373.1 378.020001,372.2 Z M391.785001,363.9 L391.785001,371.4 C391.785001,372.9 392.285001,373.3 393.185001,373.3 C393.585001,373.3 394.085001,373.2 394.785001,372.9 L394.785001,373.1 C393.785001,373.6 393.185001,373.8 392.185001,373.8 C390.785001,373.8 390.185001,373.1 390.185001,371.4 L390.185001,363.9 L388.585001,363.9 L388.585001,363.7 L390.185001,363.6 L391.585001,361.2 L391.785001,361.2 L391.785001,363.6 L394.785001,363.6 L394.785001,363.9 L391.785001,363.9 Z M400.050001,366 L400.250001,366 C401.150001,364.4 401.950001,363.4 402.950001,363.4 C403.590001,363.4 404.050001,363.84 404.050001,364.4 C404.050001,365.8 402.050001,365.9 401.950001,364.3 L401.750001,364.3 C401.230001,364.8 400.750001,365.5 400.050001,366.9 L400.050001,373.3 L401.850001,373.4 L401.850001,373.6 L396.650001,373.6 L396.650001,373.4 L398.450001,373.3 L398.450001,363.8 L396.850001,363.8 L396.850001,363.6 L399.850001,363.4 L400.050001,363.4 L400.050001,366 Z M413.715001,367.8 L406.875001,367.8 C406.815001,370.4 408.175001,372.7 410.515001,372.7 C411.815001,372.7 413.215001,371.8 413.715001,370.8 L413.915001,370.8 C413.515001,372.4 412.015001,373.8 410.115001,373.8 C407.015001,373.8 405.315001,371.3 405.315001,368.6 C405.315001,365.3 407.715001,363.4 410.215001,363.4 C412.115001,363.4 414.315001,364.5 413.715001,367.8 Z M410.115001,363.6 C408.395001,363.6 407.115001,365 406.915001,367.6 L411.915001,367.5 C412.415001,364.8 411.415001,363.6 410.115001,363.6 Z M424.580001,367.8 L417.740001,367.8 C417.680001,370.4 419.040001,372.7 421.380001,372.7 C422.680001,372.7 424.080001,371.8 424.580001,370.8 L424.780001,370.8 C424.380001,372.4 422.880001,373.8 420.980001,373.8 C417.880001,373.8 416.180001,371.3 416.180001,368.6 C416.180001,365.3 418.580001,363.4 421.080001,363.4 C422.980001,363.4 425.180001,364.5 424.580001,367.8 Z M420.980001,363.6 C419.260001,363.6 417.980001,365 417.780001,367.6 L422.780001,367.5 C423.280001,364.8 422.280001,363.6 420.980001,363.6 Z M430.045001,363.9 L430.045001,371.4 C430.045001,372.9 430.545001,373.3 431.445001,373.3 C431.845001,373.3 432.345001,373.2 433.045001,372.9 L433.045001,373.1 C432.045001,373.6 431.445001,373.8 430.445001,373.8 C429.045001,373.8 428.445001,373.1 428.445001,371.4 L428.445001,363.9 L426.845001,363.9 L426.845001,363.7 L428.445001,363.6 L429.845001,361.2 L430.045001,361.2 L430.045001,363.6 L433.045001,363.6 L433.045001,363.9 L430.045001,363.9 Z"
        id="Arbutus-Street"
        fill="#1A373C"
      />
    </>
  ),
  units: [
    {
      id: '203-303',
      mockup: (
        <g id="303" transform="translate(278.000000, 1.000000)">
          <polygon
            id="fill-303"
            stroke="#262626"
            strokeWidth="1.5"
            fill="#FFFFFF"
            fillRule="nonzero"
            points="0.349720053 0.175122807 54.0525269 0.175122807 54.0525269 31.0859433 140.216952 15.8781026 140.216952 0.175122807 212.549904 0.175122807 212.549904 103.942111 172.537432 103.942111 172.537432 136.762753 124.762399 136.762753 124.762399 158.690337 90.0425814 158.690337 90.0425814 155.365833 40.0093488 155.365833 40.0093488 103.942111 0.561426256 103.942111"
          />
          <text
            fontFamily="GlosaDisplay-Roman, Glosa Display"
            fontSize="37"
            fontWeight="normal"
            fill="#A27E42"
          >
            <tspan x="72.8618369" y="87">
              303
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: '302',
      mockup: (
        <g id="302" transform="translate(30.000000, 1.000000)">
          <polygon
            id="fill-302"
            stroke="#262626"
            strokeWidth="1.5"
            fill="#FFFFFF"
            fillRule="nonzero"
            points="248.327302 0.175122807 248.327302 103.942111 189.33184 103.942111 189.33184 155.365833 134.71164 155.365833 134.71164 184.154629 80.9382643 184.154629 80.9382643 150.272974 0.0825737847 150.272974 0.0825737847 72.7247273 13 72.7247273 0.0825737847 0.175122807"
          />
          <text
            fontFamily="GlosaDisplay-Roman, Glosa Display"
            fontSize="37"
            fontWeight="normal"
            fill="#A27E42"
          >
            <tspan x="86.3243369" y="87">
              302
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: '301',
      mockup: (
        <g id="301" transform="translate(30.000000, 151.000000)">
          <polygon
            id="fill-301"
            stroke="#262626"
            strokeWidth="1.5"
            fill="#FFFFFF"
            fillRule="nonzero"
            points="0.0825737847 0.517022942 81.0048828 0.517022942 81.0048828 34.5401457 134.570502 34.5401457 134.570502 38.9256626 173.101031 38.9256626 173.101031 36.0255628 184.32146 36.0255628 184.32146 96.3617868 185.238854 96.3617868 185.238854 186.830756 13.0114993 186.830756 0.0825737847 156"
          />
          <text
            fontFamily="GlosaDisplay-Roman, Glosa Display"
            fontSize="37"
            fontWeight="normal"
            fill="#A27E42"
          >
            <tspan x="61.4659881" y="120">
              301
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: '207-307',
      mockup: (
        <g id="307" transform="translate(215.000000, 187.000000)">
          <polygon
            id="fill-307"
            stroke="#262626"
            strokeWidth="1.5"
            fill="#FFFFFF"
            fillRule="nonzero"
            points="193.619604 150.689287 140.128503 150.689287 126.791012 122.39563 65.6079196 150.689287 0.472977752 150.689287 0.472977752 60.5032551 68.3601002 60.5032551 68.3601002 0.167031039 126.226462 0.167031039 126.226462 2.92566262 167.156328 2.92566262 167.156328 0.025562753 179.294151 0.025562753 179.294151 34.260888 193.83131 34.260888"
          />
          <text
            fontFamily="GlosaDisplay-Roman, Glosa Display"
            fontSize="37"
            fontWeight="normal"
            fill="#A27E42"
          >
            <tspan x="93.6943369" y="84">
              307
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: '206-306',
      mockup: (
        <g id="306" transform="translate(394.000000, 187.000000)">
          <polygon
            id="fill-306"
            stroke="#262626"
            strokeWidth="1.5"
            fill="#FFFFFF"
            fillRule="nonzero"
            points="153.287167 151.184426 98.2873163 151.184426 84.5917014 122.254162 21.838249 150.547819 15.244064 150.547819 15.244064 34.3795573 0.31656844 34.3795573 0.31656844 0.025562753 63.5048023 0.025562753 63.5048023 3.35006748 104.44672 3.35006748 104.44672 0.308499325 153.287167 0.308499325"
          />
          <text
            fontFamily="GlosaDisplay-Roman, Glosa Display"
            fontSize="37"
            fontWeight="normal"
            fill="#A27E42"
          >
            <tspan x="50.3068369" y="84">
              306
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: '205-305',
      mockup: (
        <g id="305" transform="translate(547.000000, 186.000000)">
          <polygon
            id="fill-305"
            stroke="#262626"
            strokeWidth="1.5"
            fill="#FFFFFF"
            fillRule="nonzero"
            points="178.777914 123.466364 114.489797 134.783827 114.489797 152.113692 0.521290703 152.113692 0.521290703 1.02556275 12.8002505 1.02556275 12.8002505 4.35006748 53.2361353 4.35006748 53.2361353 0.530423752 178.777914 0.530423752"
          />
          <text
            fontFamily="GlosaDisplay-Roman, Glosa Display"
            fontSize="37"
            fontWeight="normal"
            fill="#A27E42"
          >
            <tspan x="52.8618369" y="85">
              305
            </tspan>
          </text>
        </g>
      ),
    },
    {
      id: '304',
      mockup: (
        <g id="304" transform="translate(491.000000, 1.000000)">
          <polygon
            id="fill-304"
            stroke="#262626"
            strokeWidth="1.5"
            fill="#FFFFFF"
            fillRule="nonzero"
            points="234.777914 185.144907 109.236135 185.144907 109.236135 155.719503 57.7915279 155.719503 57.7915279 103.871377 0.0663032268 103.871377 0.0663032268 0.175122807 154.470694 0.175122807 154.470694 48.4158084 231.531752 34.7641188 234.848482 53.0842618"
          />
          <text
            fontFamily="GlosaDisplay-Roman, Glosa Display"
            fontSize="37"
            fontWeight="normal"
            fill="#A27E42"
          >
            <tspan x="97.2143369" y="103">
              304
            </tspan>
          </text>
        </g>
      ),
    },
  ],
};
